import axios from "@/lib/axios";
import { Application } from "@/types/applications";
import { Regime } from "@/types/company";
import { EditionType, InscriptionFormType } from "@/types/edition";

export type GetApplicationByEditionRequestParams = {
  companyId: string;
  editionId: string;
};

export type InscriptionForm = {
  formType: InscriptionFormType;
  id: string;
  name: string;
  resourceId: string;
};

type GetApplicationByEditionResponse = Application & {
  company: {
    id: string;
    name: string;
    segment: {
      size: Regime;
      sector: string;
      subsector: string;
    };
  };
  edition: {
    id: string;
    name: string;
    year: number;
    type: EditionType;
  };
  forms: Array<{
    id: string;
    resourceId: string;
    formType: string;
    name: string;
  }>;
};

export const getApplicationByEdition = (
  params: GetApplicationByEditionRequestParams,
) =>
  axios
    .get<GetApplicationByEditionResponse>(
      `/v1/companies/${params.companyId}/applications/edition/${params.editionId}`,
    )
    .then((res) => res.data);
